import React, { Component } from "react";
import classes from "cssClasses";
import style from "./login.scss";
import {connect} from 'react-redux';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class Login extends Component{
	render() {
		if (this.props.auth){
			return (<Redirect to="/admin" /> )
		}else{		
			return (
				<div className={classes('login',style)}>
					<div className={classes("form-signin",style)}>
						<img src="https://courses.h-farm.com/app/themes/courses-h-farm/dist//images/logo.svg" alt="-"/>
			      <h1 className={classes("h3 mb-3 font-weight-normal",style)}>Login / register</h1>
			      <a href="/auth/google" className={classes("btn btn-lg btn-primary btn-block",style)}>
	    				<FontAwesomeIcon icon="google" />
	    				Sign in with google
	    			</a>
			      <p className={classes("mt-5 mb-3 text-muted",style)}>openbadges.h-farm.com</p>
			    </div>
				</div>
			);
		}
	}
}


function mapStateToProp({auth}){
	return { auth }
}

export default connect(mapStateToProp)(Login);


// WEBPACK FOOTER //
// ./src/components/Frontend/Login/Login.js